import { render, staticRenderFns } from "./SystemSettingsLightweight.vue?vue&type=template&id=162aa674&scoped=true&"
import script from "./SystemSettingsLightweight.vue?vue&type=script&lang=js&"
export * from "./SystemSettingsLightweight.vue?vue&type=script&lang=js&"
import style0 from "./SystemSettingsLightweight.vue?vue&type=style&index=0&id=162aa674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162aa674",
  null
  
)

export default component.exports